/**
 * AB实验统一管理
 * 用于管理项目中所有的AB实验变量
 *
 * @example
 * const AB_HOT_WORD = {
 *   variableName: "hot_word",
 *   defaultValue: "string_0",
 *   map: {
 *     old: ["string_0", "string_2"],
 *     new: "string_1",
 *   },
 * };
 * const abTest = useABTest(AB_HOT_WORD);
 * // 返回 {loading: false, value: "old", old: true, new: false}
 */

// ==================== 正在运行的实验 ====================
/**
 * 画板推荐模块实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5234
 * 实验变量： similar_material_list
 * 实验值：
 *  - default: 原始版本
 *  - string_0: 对照组
 *  - string_1: 实验组1
 *  - string_2: 实验组2
 */
export const AB_SIMILAR_MATERIAL_LIST = {
  variableName: "similar_material_list",
  defaultValue: "default",
  map: {
    old: ["string_0", "default"],
    horizontal_1: "string_1",
    horizontal_2: "string_2",
  },
};

/**
 * 搜索结果页左侧筛选面板实验

 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5065
 * 实验变量： hb_search_filter_panel
 * 实验值：
 *  - old: 旧版筛选面板
 *  - new: 新版筛选面板
 *
 * 实验逻辑：
 *  - 控制搜索结果页左侧筛选面板的展示方式
 */
export const AB_SEARCH_FILTER_PANEL = {
  variableName: "hb_search_filter_panel",
  defaultValue: "new",
  map: {
    old: "old",
    new: "new",
  },
};

/**
 * @deprecated 已下线
 * 搜索tab文本实验:商用素材与源文件文案实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=4380
 * 实验变量： hb_search_tab_text
 * 实验值：
 *  - text_1: 文本1
 *  - text_2: 文本2
 *
 * 实验逻辑：
 *  - 控制搜索tab的文本显示
 */
export const AB_SEARCH_TAB_TEXT = {
  variableName: "hb_search_tab_text",
  defaultValue: "text_1",
  map: {
    planA: "text_1",
    planB: "text_2",
  },
};

/**
 * @deprecated 已下线
 * 素材详情页信息展示实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=4616
 * 实验变量： hb_detail_material_info
 * 实验值：
 *  - old: 旧版信息展示
 *  - new: 新版信息展示
 *
 * 实验逻辑：
 *  - 控制素材详情页信息的展示方式
 */
export const AB_DETAIL_MATERIAL_INFO = {
  variableName: "hb_detail_material_info",
  defaultValue: "old",
  map: {
    old: "old",
    new: "new",
  },
};

/**
 * AI工具入口跳转至art
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5099
 * 实验变量： AI_Redirect_path
 * 实验值：
 *  - string_2: 跳转到art站点
 *  - 其他: 跳转到默认站点
 *
 * 实验逻辑：
 *  - 控制AI工具入口的跳转路径
 */
export const AB_AI_REDIRECT_PATH = {
  variableName: "AI_Redirect_path",
  defaultValue: "string_0",
};

/**
 * 画板推荐模块实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5164
 * 实验变量： art_recommend_board_list
 * 实验值：
 *  - old: 旧版推荐模块
 *  - new: 新版推荐模块
 */
export const AB_ART_RECOMMEND_BOARD_LIST = {
  variableName: "art_recommend_board_list",
  defaultValue: "old",
};

/**
 * 搜索结果页-推荐搜索词实验

 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5168
 * 实验变量： search_feed_words
 * 实验值：
 *  - string_0: 原始组 无推荐搜索词
 *  - string_1: 实验组 有推荐搜索词
 *  - string_2: 对照组 无推荐搜索词
 *
 * 实验逻辑：
 *  - 控制采集详情页推荐模块的优化策略
 */
export const AB_SEARCH_FEED_WORDS = {
  variableName: "search_feed_words",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

export const AB_PIN_DETAIL_AIGAMEPLAY = {
  variableName: "hb_pindetail_aigameplay",
  defaultValue: "show",
  map: {
    show: ["show"],
    hide: ["hide"],
  },
};

/**
 * 花瓣全屏采集详情页
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5191
 * 实验变量： hb_pindetail_feed
 * 实验值：
 *  - old: 原始组 & 对照组
 *  - feed: 实验组
 */
export const AB_PIN_DETAIL_FULLSCREEN = {
  variableName: "hb_pindetail_feed",
  defaultValue: "old",
  map: {
    old: "old",
    new: ["feed", "string_3"],
  },
};

/**
 * 用户信息统一与管理
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5208
 * 实验变量： userinfo_settings
 * 实验值：
 *  - string_0: 原始版本
 *  - string_1: 实验版本
 *  - string_2: 对照组
 *
 * 实验逻辑：
 *  - 控制用户信息统一与管理
 */
export const AB_USERINFO_SET = {
  variableName: "userinfo_settings",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 详情页为你推荐插入词和主题
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5202
 * 实验变量： hb_pin_word_topic
 * 实验值：
 *  - string_0: 原始组
 *  - string_1: 实验组
 *  - string_2: 对照组
 */
export const AB_PIN_WORD_TOPIC = {
  variableName: "hb_pin_word_topic",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 灵感顶部导航画板推荐实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5189
 * 实验变量： board_recommend_pin_v2
 * 实验值：
 *  - string_0: 原始组
 *  - string_1: 纯后端逻辑优化
 *  - string_2: 后端+前端加坑位
 *  - string_3: 对照组
 */
export const AB_DISCOVERY_NAV = {
  variableName: "board_recommend_pin_v2",
  defaultValue: "string_2",
  map: {
    old: ["string_0", "string_1", "string_3"],
    new: ["string_2"],
  },
};

/**
 * 会员订购入口优化实验
 * 实验变量： pricing_new_ent
 * 实验值：
 *  - string_0: 原始版本（显示角标和popover）
 *  - string_1: 实验组
 *  - string_2: 仅显示角标版本（不显示popover弹窗）
 *
 * 实验逻辑：
 *  - string_2时仅保留角标，不展开下面的popover弹窗
 */
export const AB_PRICING_NEW_ENT = {
  variableName: "pricing_new_ent",
  defaultValue: "string_0",
  map: {
    hidePopover: "string_2",
    hidePanel: "string_2",
  },
};

/**
 * 多人画板功能实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5203
 * 实验变量： hb_multi_board
 * 实验值：
 *  - string_0: 原始组
 *  - string_1: 实验组
 *  - string_2: 对照组
 *
 * 实验逻辑：
 *  - 控制多人画板的展示方式
 */
export const AB_MULTI_BOARD = {
  variableName: "hb_multi_board",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};

/**
 * 画板推荐模块实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5221
 * 实验变量： hb_recommend_create_board
 * 实验值：
 *  - string_0: 原始版本
 *  - string_1: 实验组1
 *  - string_2: 实验组2
 */
export const AB_RECOMMEND_CREATE_BOARD = {
  variableName: "hb_recommend_create_board",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 花瓣站点灵感发散入口通过 AB 控量限制
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5236
 * 实验变量： hb_ugc_image_analysis_entrance
 * 实验值：
 *  - string_0: 原始版本
 *  - string_1: 实验组
 */
export const AB_INSPIRATION_IMAGE_ANALYSIS = {
  variableName: "hb_ugc_image_analysis_entrance",
  defaultValue: "string_0",
  map: {
    old: ["string_0"],
    new: ["string_1"],
  },
};
